<template>
  <b-container class="page-container" fluid>
    <SeventeenMonthsCheckout />
  </b-container>
</template>
<style>

</style>

<script>
// @ is an alias to /src
import SeventeenMonthsCheckout from "@/components/checkout/seventeenmonths/SeventeenMonthsCheckout.vue";

export default {
  title: 'Seventeen Months of Dropsmart',
  name: "SeventeenMonthsView",
  components: {
    SeventeenMonthsCheckout
  }
};
</script>
